// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.multiselect__input[readonly]:not([disabled]) {\n  background-color: var(--white);\n}\n.multiselect__container, .multiselect__input_container {\n  position: relative;\n}\n.multiselect__dropdown {\n  display: block;\n}\n.multiselect__dropdown-items {\n  max-height: 200px;\n  overflow-y: auto;\n}\n.multiselect__spinner {\n  position: absolute;\n  right: 10px;\n  top: calc(50% - .5rem);\n}\n\n", ""]);
// Exports
module.exports = exports;
